<template>
    <div>
        <storage-box
            :homepage_version="homepage_version"
        ></storage-box>
    </div>
</template>
<script>
    import StorageBox  from '../../global/storage-box.vue';

    export default {
        name: 'box-overview',
        props: ['homepage_version'],
        data() {
            return {
                storage_box: null
            }
        },
        components: {
            'storage-box' : StorageBox,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/boxes/box-overview.vue